export interface IProfileDataValidation {
    name: boolean,
    webUrl: boolean,
    earliestPickupTime: number,
    latestOrganPickupTime: boolean,
    timezone: boolean;
    taxExemptExpirationDate: boolean
    newTaxFile: boolean,
    leadCoordinator: boolean
}